module.exports = __webpack_public_path__ + "static/img/quote-close.728ccd24.svg";